const LuxeInn=[
    
{
      src: 'https://imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/bgdefault_bg.jpg',
      alt: 'Daan Ambalath',
    },
{
      src: 'https://imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/bgdefault_bg.jpg',
      alt: 'Daan Ambalath',
    },{
      src: 'https://imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/bgdefault_bg.jpg',
      alt: 'Daan Ambalath',
    },{
      src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/776350599.jpg?k=4b9e5c9af59b55377714321bb35f6134643ac5ec5dd630e396f7ab548b8feb9c&o=',
      alt: 'Daan Ambalath',
    },



]

export default LuxeInn;